import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Component from "./Components";
import Pages from "./pages";
import strings from "./utils/strings";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";

function Navigation() {
  return (
    <Routes>
      <Route element={<PublicRoute element={Component.CommonLayout} />}>
        <Route exact path={strings.navigation.welcome} element={<Pages.WelcomeScreen />} />
      </Route>
      <Route element={<PrivateRoute element={Component.SessionValidation} />}>
        <Route element={<Component.LayoutComponent />}>
          <Route exact path={strings.navigation.department} element={<Pages.Department />} />
          <Route exact path={strings.navigation.departmentPrice} element={<Pages.DepartmentPrice />} />
          <Route exact path={strings.navigation.patientProfile} element={<Pages.PatientProfile />} />
          <Route exact path={strings.navigation.manageDriver} element={<Pages.DriverProfile />} />
          <Route exact path={strings.navigation.manageAmbulance} element={<Pages.Ambulance />} />
          <Route exact path={strings.navigation.manageNurseReq} element={<Pages.NurseRequest />} />
          <Route exact path={strings.navigation.viewNurseReqDetails} element={<Pages.ServiceDetails />} />

          {/* NURSING CARE */}
          <Route exact path={strings.navigation.editNurse} element={<Component.EditNurse />} />
          <Route exact path={strings.navigation.createNurse} element={<Component.CreateNurse />} />
          <Route exact path={strings.navigation.nurseList} element={<Component.NurseList />} />
          <Route exact path={strings.navigation.additionalConsumableList} element={<Component.AdditionalConsumableList />} />
          <Route exact path={strings.navigation.addConsumable} element={<Component.CreateConsumableList />} />
          <Route exact path={strings.navigation.editConsumable} element={<Component.EditConsumable />} />
          <Route exact path={strings.navigation.healthArticle} element={<Pages.Article />} />
          <Route exact path={strings.navigation.nationalID} element={<Pages.NationalID />} />
          <Route exact path={strings.navigation.termsCondition} element={<Pages.TermsCondition />}>
            <Route index element={<Component.ListTermsCondition />} />
            <Route path="update" element={<Component.EditTermsCondition />} />
            <Route path="view" element={<Component.ViewTermsCondition />} />
          </Route>

          <Route path={strings.navigation.nursingCareManageService} element={<Component.ManageServicesList />} />
          <Route path={strings.navigation.createService} element={<Component.CreateServiceMain />} />
          <Route path={strings.navigation.serviceDetail} element={<Component.ManageRequestServiceDetails />} />
        </Route>
      </Route>
      <Route path="*" element={<Pages.PageNotFound />} />
    </Routes>
  );
}

export default Navigation;
